import React, { useState } from 'react';
import { LibraryBook, coverUrl } from '../data/library';
interface BookCoverProps {
  book: LibraryBook;
  /* decorative covers inside a labelled card do not need repeating alt text */
  decorative?: boolean;
}

/* Real PDF cover thumbnail from Drive, with a typeset fallback for the days
   Drive declines to render one. object-contain so a portrait cover is never
   cropped. */
export function BookCover({
  book,
  decorative = false
}: BookCoverProps) {
  const [failed, setFailed] = useState(false);
  const number = String(book.n).padStart(2, '0');
  if (failed) {
    return <div className="flex h-full w-full flex-col justify-between bg-navy p-5 text-left" data-id="element-67" data-mp="2efc0vd8d1hm5">
        <span className="font-sans text-[11px] font-semibold tracking-[0.16em] text-sun" data-id="element-68" data-mp="29h0q90a8r32v">
          BOOK {number}
        </span>
        <span className="font-display text-[22px] font-semibold leading-tight text-paper" data-id="element-69" data-mp="24gmg9cp2xj27">
          {book.title}
        </span>
      </div>;
  }
  return <img src={coverUrl(book.fileId)} alt={decorative ? '' : `Cover of Book ${number}, ${book.title}`} aria-hidden={decorative || undefined} loading="lazy" onError={() => setFailed(true)} className="h-full w-full object-contain" data-id="element-70" data-mp="19arfrdispxvr" />;
}